// Current Lodge Reducer

import { initializeState } from '../../../utilities/storageUtils';
import currentLodgeActionTypes from './currentLodge.types';

const INITIAL_STATE = {
  resortLocation: ''
};

const currentLodgeReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  switch (action.type) {
    case currentLodgeActionTypes.UPDATE_CURRENT_LODGE:
      return {
        resortLocation: action.resortLocation
      };
    default:
      return state;
  }
};

export default currentLodgeReducer;
